<template>
  <div class="pdp-headline">
    <h3 v-html="headline" />
  </div>
</template>

<script>

export default {
  props: {
    headline: {
      type: String,
      default() {
        return ''
      }
    }
  }

}
</script>

<style lang="scss">
.pdp-headline {
  margin-top: 0;

  h3 {
    margin-top: 0;
    margin-bottom: .5rem;

    @include breakpoint-up($md) {
      position:relative;
      top: -.325rem;
    }
  }
}
</style>
